import { render, staticRenderFns } from "./QuizApproved.vue?vue&type=template&id=551aa20a&scoped=true"
import script from "./QuizApproved.vue?vue&type=script&lang=js"
export * from "./QuizApproved.vue?vue&type=script&lang=js"
import style0 from "./QuizApproved.vue?vue&type=style&index=0&id=551aa20a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551aa20a",
  null
  
)

export default component.exports